import { render } from "./CustomTopicModelGroups.vue?vue&type=template&id=5356833f&scoped=true"
import script from "./CustomTopicModelGroups.vue?vue&type=script&lang=js"
export * from "./CustomTopicModelGroups.vue?vue&type=script&lang=js"

import "./CustomTopicModelGroups.vue?vue&type=style&index=0&id=5356833f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5356833f"]])

export default __exports__